import { render } from "./Calendar.vue?vue&type=template&id=c45acd26"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=c45acd26&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\program\\Telegram Reminder\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__